import { cn } from "../../../utils/class-names";
import { buttonV2, ButtonV2 } from "../../button-v2";
import { CheckmarkIcon } from "../../../icons/checkmark";
import { UnstyledLink } from "../../link";
import { LINKS } from "@silo/types";
import { ExternalLinkIcon } from "../../../icons";

export interface VersionGroupProps {
  className?: string;
  onSelect: () => void;
}

export function VersionGroup({
  className,
  onSelect,
}: VersionGroupProps): JSX.Element {
  return (
    <div className="flex flex-col gap-10">
      <div className="text-xl font-medium text-white">Version</div>

      <div
        className={cn(
          "flex flex-col gap-5 items-stretch sm:items-start",
          className
        )}
      >
        <ButtonV2
          variant="secondary"
          onClick={() => onSelect()}
          className="flex items-center justify-between gap-5"
          isSelected
        >
          App v1
          <CheckmarkIcon className="w-6 h-6" />
        </ButtonV2>

        <UnstyledLink
          className={buttonV2({
            variant: "secondary",
            className: "flex items-center gap-2.5",
          })}
          href={LINKS.V2}
          external
          onClick={() => onSelect()}
        >
          v2
          <ExternalLinkIcon className="w-4 h-4 text-shale-400" />
        </UnstyledLink>

        <UnstyledLink
          className={buttonV2({
            variant: "secondary",
            className: "flex items-center gap-2.5",
          })}
          href={LINKS.V3}
          external
          onClick={() => onSelect()}
        >
          v3
          <ExternalLinkIcon className="w-4 h-4 text-shale-400" />
        </UnstyledLink>
      </div>
    </div>
  );
}
